import React from "react";

const Promotion = () => {
  return (
    <>
      {/* <!-- promotion area start  --> */}
      <div className="tp-promotion-area p-relative grey-bg-4">
        <div
          className="tp-promotion-bg grey-bg"
          style={{
            backgroundImage: `url('assets/img/promotion/promotion.jpg')`,
          }}
        ></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-6">
              <div className="tp-promotion-info pt-110 pb-80 pl-120">
                <div className="tp-section-wrapper">
                  <span className="tp-section-subtitle mb-25">
                    Core Expertise
                  </span>
                  <h2 className="tp-pt-size mb-90">
                    Shaping Brands, Businesses & Innovation for the Future
                  </h2>
                </div>
                <div className="tp-promotion-progress">
                  <div className="tp-progress-item p-relative mb-45">
                    <h4>Brand Development & Management</h4>
                    <span className="tp-progress-count">90%</span>
                    <div className="progress">
                      <div
                        className="progress-bar wow slideInLeft"
                        data-wow-duration="1s"
                        data-wow-delay=".3s"
                        role="progressbar"
                        data-width="90%"
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          width: "90%",
                          visibility: "visible",
                          animationDuration: "1s",
                          animationDelay: "0.3s",
                          animationName: "slideInLeft",
                          backgroundColor: "#0ABAB5",
                        }}
                      ></div>
                    </div>
                  </div>
                  <div className="tp-progress-item p-relative mb-45">
                    <h4>Media & Production</h4>
                    <span className="tp-progress-count mb30">92%</span>
                    <div className="progress">
                      <div
                        className="progress-bar wow slideInLeft"
                        data-wow-duration="1s"
                        data-wow-delay=".3s"
                        role="progressbar"
                        data-width="92%"
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          width: "92%",
                          visibility: "visible",
                          animationDuration: "1s",
                          animationDelay: "0.3s",
                          animationName: "slideInLeft",
                          backgroundColor: "#0ABAB5",
                        }}
                      ></div>
                    </div>
                  </div>
                  <div className="tp-progress-item p-relative mb-45">
                    <h4>Fashion & Lifestyle</h4>
                    <span className="tp-progress-count">89%</span>
                    <div className="progress">
                      <div
                        className="progress-bar wow slideInLeft"
                        data-wow-duration="1s"
                        data-wow-delay=".3s"
                        role="progressbar"
                        data-width="70%"
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          width: "89%",
                          visibility: "visible",
                          animationDuration: "1s",
                          animationDelay: "0.3s",
                          animationName: "slideInLeft",
                          backgroundColor: "#0ABAB5",
                        }}
                      ></div>
                    </div>
                  </div>
                  <div className="tp-progress-item p-relative mb-45">
                    <h4>Metals & Commodities</h4>
                    <span className="tp-progress-count">90%</span>
                    <div className="progress">
                      <div
                        className="progress-bar wow slideInLeft"
                        data-wow-duration="1s"
                        data-wow-delay=".3s"
                        role="progressbar"
                        data-width="70%"
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          width: "90%",
                          visibility: "visible",
                          animationDuration: "1s",
                          animationDelay: "0.3s",
                          animationName: "slideInLeft",
                          backgroundColor: "#0ABAB5",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="tp-promotion-area p-relative grey-bg-4">
        <div
          className="tp-promotion-bg-2"
          style={{
            backgroundImage: `url('/assets/img/promotion/promotion-1.jpg')`,
          }}
        ></div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6">
              <div className="tp-promotion-info-2 pt-110 pb-120 pl-120">
                <div className="tp-section-wrapper">
                  <span className="tp-section-subtitle mb-25">
                    Live Data Analyisis
                  </span>
                  <h2 className="tp-pt-size mb-90">
                    Long Turms planing for <br />
                    your unlimited Success
                  </h2>
                </div>
                <div className="tp-promotion-progress">
                  <div className="tp-promotion-graph">
                    <img
                      src="/assets/img/promotion/pt-graph.png"
                      alt="bg img"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <!-- promotion area end  --> */}
    </>
  );
};

export default Promotion;
